import React from "react";
import IndustriesSub from "./IndustriesSub";

class MainSub extends React.Component {
    render() {
        return (
            <main
                role="main"
                className={`main main--sub ${
                    this.props.isGuideOpen ? "main--blur" : ""
                }`}
            >
                <h2 className="wrapper appetite__heading appetite__heading--sect appetite__heading--sub wrapper">
                    Select a sector
                </h2>
                <section className="tile__holder tile__holder--sub wrapper">
                    {<IndustriesSub {...this.props} className={`tab`} />}
                </section>
            </main>
        );
    }
}

export default MainSub;



// WEBPACK FOOTER //
// ./src/components/MainSub.js